import { createRoot } from 'react-dom/client';
import React from 'react';

function toBindings(propTypes) {
    const bindings = {};
    Object.keys(propTypes).forEach((key) => { bindings[key] = '<'; });
    return bindings;
}

function toProps(propTypes, controller) {
    const props = {};
    Object.keys(propTypes).forEach((key) => { props[key] = controller[key]; });
    return props;
}

export function reactToAngularComponent(Component) {
    const propTypes = Component.propTypes || {};

    return {
        bindings: toBindings(propTypes),
        controller: ['$element', function ($element) {
            this.element = createRoot($element[0]);
            this.$onChanges = () => {
                const props = toProps(propTypes, this);
                this.element.render(<Component { ...props } />);
            };
            this.$onDestroy = () => {
                if (this.element) {
                    this.element.unmount();
                }
            };
        }],
    };
}

export function getAngularService(name) {
    // eslint-disable-next-line angular/document-service
    const injector = angular.element(document.body).injector();
    if (!injector || !injector.get) {
        throw new Error(`Couldn't find angular injector to get "${name}" service`);
    }

    const service = injector.get(name);
    if (!service) {
        throw new Error(`Couldn't find "${name}" angular service`);
    }

    return service;
}
